import { Box, Stack, keyframes } from '@mui/material';

import Iconify from '../iconify';

// ----------------------------------------------------------------------

// Animation thở (breathing)
const breatheAnimation = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

// Animation glow sáng lên
const glowAnimation = keyframes`
  0%, 100% {
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }
  50% {
    box-shadow: 0 4px 25px currentColor, 0 0 35px currentColor;
  }
`;

// Animation floating nhẹ nhàng
const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
`;

export default function FloatingSocialButtons() {
  return (
    <Stack
      direction="column"
      spacing={1.5}
      sx={{
        position: 'fixed',
        bottom: 100,
        right: 24,
        zIndex: 9999,
      }}
    >
      <Box
        component="a"
        href="tel:0762961199"
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: '#4CAF50',
          color: 'rgba(76, 175, 80, 0.5)',
          boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
          textDecoration: 'none',
          animation: `${breatheAnimation} 3s ease-in-out infinite, ${glowAnimation} 3s ease-in-out infinite, ${floatAnimation} 3s ease-in-out infinite`,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'scale(1.2) translateY(-5px)',
            boxShadow: '0 8px 30px rgba(76, 175, 80, 0.6)',
            animation: 'none',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: -3,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, transparent 100%)',
            opacity: 0.5,
          },
        }}
      >
        <Iconify icon="solar:phone-bold" width={28} color="white" />
      </Box>

      <Box
        component="a"
        href="https://zalo.me/0762961199"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: '#0068FF',
          color: 'rgba(0, 104, 255, 0.5)',
          boxShadow: '0 4px 12px rgba(0, 104, 255, 0.3)',
          textDecoration: 'none',
          animation: `${breatheAnimation} 3s ease-in-out 0.5s infinite, ${glowAnimation} 3s ease-in-out 0.5s infinite, ${floatAnimation} 3s ease-in-out 0.5s infinite`,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'scale(1.2) translateY(-5px)',
            boxShadow: '0 8px 30px rgba(0, 104, 255, 0.6)',
            animation: 'none',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: -3,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, transparent 100%)',
            opacity: 0.5,
          },
        }}
      >
        <Iconify icon="simple-icons:zalo" width={28} color="white" />
      </Box>

      <Box
        component="a"
        href="https://www.facebook.com/profile.php?id=100076055690904"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: '#1877F2',
          color: 'rgba(24, 119, 242, 0.5)',
          boxShadow: '0 4px 12px rgba(24, 119, 242, 0.3)',
          textDecoration: 'none',
          animation: `${breatheAnimation} 3s ease-in-out 1s infinite, ${glowAnimation} 3s ease-in-out 1s infinite, ${floatAnimation} 3s ease-in-out 1s infinite`,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'scale(1.2) translateY(-5px)',
            boxShadow: '0 8px 30px rgba(24, 119, 242, 0.6)',
            animation: 'none',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: -3,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, transparent 100%)',
            opacity: 0.5,
          },
        }}
      >
        <Iconify icon="ic:baseline-facebook" width={28} color="white" />
      </Box>
    </Stack>
  );
}
